import Modal from "@mui/material/Modal";
import { Fragment } from "react";
import {
  ArrowBackStyled,
  ArrowNextStyled,
  CircularProgressStyled,
  CloseIconStyled,
  ImageStyled,
  LeftButtonContainer,
  MediaContainer,
  ReactPlayerStyled,
  RightButtonContainer,
  TypographyStyled,
} from "./styles";

/**
 * EXAMPLE FOR HOW TO USE THIS MODAL
 * 
 <SingleJobMediaModal
    media={combinedMediaForModal} // all the media of the company (Array of String, media urls with https)
    currentMediaIndex={currentMediaIndex} // index of the selected media for viewing upon onclick event (Integer)
    open={openModal} // boolean to toggle whether modal is open or close (boolean, from a useState hook)
    setOpenModal={setOpenModal} // setState to open or close the modal (function, setState from a useState hook)
    handleClickMedia={handleClickMedia} // function to open the modal, and change state of current media index
  />
 */
export default function SingleJobMediaModal(props) {
  const {
    companyDetail,
    media,
    currentMediaIndex,
    open,
    setOpenModal,
    handleClickMedia,
  } = props || {};

  const currentMedia =
    Array.isArray(media) && media[currentMediaIndex]
      ? media[currentMediaIndex]
      : "";

  function handlePreviousMedia() {
    if (currentMediaIndex === 0) {
      handleClickMedia(media.length - 1);
    } else {
      handleClickMedia(currentMediaIndex - 1);
    }
  }

  function handleNextMedia() {
    if (currentMediaIndex === media.length - 1) {
      handleClickMedia(0);
    } else {
      handleClickMedia(currentMediaIndex + 1);
    }
  }

  return (
    <Modal
      open={open}
      onClose={() => setOpenModal(false)}
      sx={{
        width: "100%",
      }}
    >
      <Fragment>
        <LeftButtonContainer onClick={() => handlePreviousMedia()}>
          <ArrowBackStyled />
        </LeftButtonContainer>
        <MediaContainer flexDirection={"column"}>
          {!currentMedia || currentMedia == "" ? (
            <CircularProgressStyled />
          ) : currentMedia.includes("vimeo") ? (
            <ReactPlayerStyled
              key={`video-vimeo`}
              url={currentMedia}
              controls={true}
              playing={true}
              playsinline={true}
              config={{
                file: {
                  attributes: {
                    "webkit-playsinline": true,
                  },
                },
              }}
            />
          ) : (
            <ImageStyled
              alt={companyDetail?.name + "company picture" + currentMediaIndex}
              src={
                currentMedia.includes("https")
                  ? currentMedia
                  : "https:" + currentMedia
              }
              loading="lazy"
              style={{
                objectFit: "contain",
              }}
            />
          )}
          <TypographyStyled variant="subtitle1">
            {currentMediaIndex + 1}/{media.length}
          </TypographyStyled>
        </MediaContainer>
        <CloseIconStyled onClick={() => setOpenModal(false)} />
        <RightButtonContainer $right_button onClick={() => handleNextMedia()}>
          <ArrowNextStyled />
        </RightButtonContainer>
      </Fragment>
    </Modal>
  );
}
